import SuiviDroitBitumeController from './suivi.droit.bitume.controller';

export default {
    template: require('./suivi.droit.bitume.html'),
    controller: SuiviDroitBitumeController
};
